import Vue from 'vue'

export const EventBus = new Vue({
})

// const messageBus = new Vue({
//     methods: {
//         showNotification: function(notificationVisible) {
//             if(notificationVisible) {
//                 this.logConsole("Nofication marked as visible");
//             } else {
//                 this.logConsole("Nofication marked as hidden");
//             }
//         }
//     },
//     created: function () {
//         this.logConsole("Message bus created");
//     }
// })

// Vue.use(messageBus);



// WEBPACK FOOTER //
// ./src/router/bus.js